var shouldDebug = false; // Should the generator display debug messages on the console?
var shouldClearResults = false; // The list of results must be cleared each time the "Create Brands!" is pressed?
var resultsPerRound = 20; // How many results will be generated each time the "Create Brands!" is pressed?
var $results = document.querySelector('.js-results');
var $resultsWrapper = document.querySelector('.js-result-wrapper');
var $heroContent = document.querySelector('.js-slogan-hero');
var $heroContentSuccess = document.querySelector('.js-slogan-hero-success');
var $forms = document.querySelector('.js-slogan-form');
var $brandVertical = document.getElementsByName('brand-vertical');
const CREATE_ACCOUNT_MODAL = legacyLayout ? '#modal-create-account' : '#modal-create-account-v2';
var state = {};
var userEmail = '';

function start() {

    state.stepTo = legacyLayout ? 2 : 1;
    state.stepFrom = legacyLayout ? (state.stepTo - 1) : 1;

    var $btnNext = document.querySelector('.js-slogan-next'),
        $createBrand = document.querySelector('.js-results-button'),
        $brandName = document.getElementById('company'),
        $modalSubscribe = $("#modal-subscribe");

    // Get brandname from URL if exists
    if(location.search !== '' && location.search.includes('brandname')) {
        var getBrandNameFromUrl = decodeURI(window.location.search.replace('?brandname=', ''));
        $brandName.value = getBrandNameFromUrl;
    }

    if((subpathName && !!hasSubdirName) && legacyLayout) {
        handleSteps(2,1);
    } else {
        handleSteps(state.stepFrom, state.stepTo)
    }
    handleToggleFields();

    $(CREATE_ACCOUNT_MODAL).on('hidden.bs.modal', function (e) {
        amplitude_log_event('tools_slogan_modal_register_closed')
    })

    $(CREATE_ACCOUNT_MODAL).on('show.bs.modal', function (e) {
        amplitude_log_event('tools_slogan_modal_register_opened')
    })

    $modalSubscribe.on('hidden.bs.modal', function (e) {
        amplitude_log_event('tools_slogan_modal_subscribe_closed')
    });

    $modalSubscribe.on('show.bs.modal', function (e) {
        amplitude_log_event('tools_slogan_modal_subscribe_opened')
    });

    $btnNext && $btnNext.addEventListener('click', function(e) {
        e.preventDefault();
        var validate = handleValidate($brandVertical, 1);

        if (validate) {
            handleSteps(state.stepTo, state.stepFrom);
            return;
        }
    });

    $createBrand.addEventListener('click', function(event){
        event.preventDefault();

        var currentStepToValidate = legacyLayout ? 2 : 1;

        var validate = handleValidate($brandName, currentStepToValidate),
            $form = $('.js-slogan-form'),
            formFieldsArr = $form.serializeArray();

        filteredItem = formFieldsArr.filter(function (el) {
            return el !== null && el !== "" && el.value !== '';
        });

        if (validate) {
            if(hasSubscribeFlow && HUBSPOT_FORM_EMBED.currenStep() !== 'finish') {
                $('#modal-subscribe').modal();

                return;
            }

            handleScroll();
            createResults(filteredItem);
        }

    });

    $brandName.addEventListener('blur', function(event) {
        handleValidate($brandName, legacyLayout ? 2 : 1);
    })

    $('#modal-subscribe').on('show.bs.modal', function () {

        // close any opened modal before open subscribe modal
        var currentModal = this;

        $(".modal").each(function() {
        if (this !== currentModal) {
            $(this).fadeOut(500, function() {
                $(this).modal('hide');
            });
        }
        });

        toolsSubscribe('.js-form-subscribe', {
            onReady: function() {
                // Save user email to prepopulate in next modal
                const subscribeBtn = document.querySelector('.hs-button');
                subscribeBtn.addEventListener('click', function() {
                    let hasEmailInput = document.querySelector('.hs-email') !== null;
                    if(hasEmailInput) {
                        let inputEmailValue = document.querySelector('.hs-email').getElementsByTagName('input')[0].value;
                        userEmail = inputEmailValue;
                    }
                })
            }
        })
    });

    document.addEventListener('onToolsSubscribe', function() {
        if(hasSubscribeFlow) {
            handleScroll();
            createResults(filteredItem);
        }

        $('#modal-subscribe').modal('hide');

        amplitude_log_event('tools_slogan_subscribed');
    })
}

function handleScroll(to) {
    window.scrollTo({
        top: to ? to : 0,
        behavior: 'smooth'
    });
}

function handleValidate($fields, step) {
    var is_checked = false,
        is_selected = false,
        is_filled = false,
        is_valid;

    var $step = document.querySelector('.js-step-' + step);

    // check if field is valid

    if ($fields.length > 1) {
        $fields.forEach(element => {
            if (element.type == 'radio' && element.checked) {
                is_checked = true;
            }

            if (element.selectedIndex > 0) {
                is_selected = true;
            }
        });
    } else {
        if(!$fields.value == '') {
            is_filled = true;
        }
    }

    is_valid = is_checked || is_selected || is_filled  ? true : false;

    if ($step.querySelector('.error')) {
        $step.querySelector('.error').remove();
    }

    if (!is_valid) {

        var errorElement = document.createElement('p');

        errorElement.classList.add('error', 'text-center', 'm-top', 'c-dark-blue');
        errorElement.dataset.generated = true;
        errorElement.textContent = step == 1 && legacyLayout ? specialValidateSegmentsError : specialValidateBrandWordError;

        $step.appendChild(errorElement);
    }

    handleHeight(step);

    return is_valid;
}

function handleRegenerate() {
    state.stepTo = legacyLayout ? 2 : 1;
    state.stepFrom = legacyLayout ? (state.stepTo - 1) : 1;
    state.statusOfSelect = false;

    $forms.reset();
    handleResults(null);
    clearResults();
    handleSteps(state.stepFrom, state.stepTo);
    handleScroll();
}

function handleToggleFields () {
    $categorySelect = document.querySelector('.js-other-categories');
    $categoryName = document.getElementsByName('brand-vertical');

    $categorySelect.addEventListener('change', function (e) {
        $categoryName.forEach(element => {
            if (element.type == 'radio') {
                // select event
                element.checked = false
            }
        });
        handleValidate($brandVertical, 1);
    });

    $categoryName.forEach(element => {
        if (element.type == 'radio') {
            // select event
            element.addEventListener('change', function (e) {
                $categorySelect.selectedIndex = "0";
                handleValidate($brandVertical, 1);
            })
        }
    });
}


//===========================================================================================================================
function createResults( fieldsObject, shouldClearResults ){

    var brandName = fieldsObject[1].value,
        brandSegment = fieldsObject[0].value,
        brandNamesList = [];

    // define index of category
    // TODO - passing index by html
    for (var index = 0; index < brandingContents.length; index++) {
        if (brandingContents[index]["nice_name"] == brandSegment) {
            var wordsIndex = index;
        }
    }

    if (shouldClearResults){
        clearResults();
    }

    //We will generate [resultsPerRound] tags. Each time a currentWord is used, it will be discarded from the array.
    brandingContents[wordsIndex]["words"].forEach(finalResult => {
        debug("The final mark is: "+ finalResult);
        brandNamesList.push(finalResult)
    });


    handleResults(brandNamesList, brandName);
    handleActionButtons()

    if (!shouldClearResults) {
        amplitude_log_event('tools_slogan_created', {
            segment: brandSegment
        })
    }

    debug("Finished results");

}

function handleResults(slogans, brandName) {
    var $form = document.querySelector('.js-slogan-form');
    var $resultItem = document.querySelector('.js-result-list-template');

    if (slogans) {
        slogans.forEach(element => {
            var $clone = $resultItem.cloneNode(true).content,
                $brandName = $clone.querySelector('.js-result-brandname');
                $slogan = $clone.querySelector('.js-result-slogan');

            $clone.querySelector('button').dataset.brandName = brandName;
            $clone.querySelector('button').dataset.slogan = element;
            $brandName.innerHTML = brandName;
            $slogan.innerHTML = element;
            $results.append($clone);
        });

        var $brandsButton = $results.querySelectorAll('.js-result-list-link');

        for (var i = 0; i < $brandsButton.length; i++) {
            $brandsButton[i].addEventListener('click', function(e) {
                e.preventDefault();
                handleResultBrandsButtons(e.target, e.target.dataset.brandName, e.target.dataset.slogan)
            })
        }

        // Success moment
        $form.classList.add('slide-up-out');
        $heroContent.classList.add('slide-up-out');

        setTimeout(function(){
            $form.classList.add('hide');
            $heroContent.classList.add('hide');

            $resultsWrapper.classList.add('slide-up-delay');
            $resultsWrapper.classList.remove('hide');

            $heroContentSuccess.classList.remove('hide');
            $heroContentSuccess.classList.add('slide-up');
        }, 100);

        setTimeout(function(){
            document.addEventListener('mouseout', mouseEvent);
            document.addEventListener('keydown', exit);
        } ,5000)

        return;
    }

    // if recreate form

    $form.classList.remove('slide-up-out', 'hide');
    $heroContent.classList.remove('slide-up-out', 'hide');

    $resultsWrapper.classList.add('hide');
    $resultsWrapper.classList.remove('slide-up-delay');

    $heroContentSuccess.classList.add('hide');
    $heroContentSuccess.classList.remove('slide-up');
}


//===========================================================================================================================
//Função que limpa a lista de resultados
function clearResults(){
    $results.innerHTML = '';
    document.removeEventListener('mouseout', mouseEvent);
    document.removeEventListener('keydown', exit);
}

//===========================================================================================================================
//Função que exibe mensagens de debug no console, se a variavel shouldDebug == true;
function debug($content){
    if (shouldDebug){
        console.log($content);
    }
}


// TODO Fixing error with dispatch events

function handleActionButtons( shouldCreateAgain, restItems ) {

    var $form = $('.js-slogan-form'),
        $createOtherBrand = document.querySelectorAll('.js-other-brand');

    $createOtherBrand.forEach(function(el){
        el.addEventListener('click', function(){
            handleRegenerate();
            amplitude_log_event('tools_slogan_recreate');
        });
    })

}

function handleResultBrandsButtons($el, brandName, slogan) {
    $(CREATE_ACCOUNT_MODAL).modal('show');

    var $registerForm = document.querySelector('.js-tkit-loading-form'),
        $storeName = $registerForm.querySelector('.name'),
        $storeNameTitle = document.querySelector('.js-slogan-title'),
        $storeEmail = $registerForm.querySelector('.email');

    $storeName.value = brandName + ' (' + slogan + ')';
    $storeEmail.value = userEmail;

    if($storeNameTitle) {
        $storeNameTitle.innerText = brandName;
    }

    if(!legacyLayout) {
        const $modalImageBrandName = document.querySelector('.js-modal-image-brand');

        $modalImageBrandName.innerHTML = '<span class="text-uppercase">'+brandName+'</span><br>'+'<span class="c-dark-blue slide-up slide-up-fast">'+slogan+'</span>';
        $modalImageBrandName.classList.add('slide-up-fast', 'slide-up');
        $modalImageBrandName.style.top = '50.3%';
        $modalImageBrandName.style.left = '33%';
        $modalImageBrandName.style.fontSize = '11px';

        if($storeName.value != "" && language != 'BR') {
            $registerForm.querySelector('.js-group-storename').classList.add('hide');
        }
    }

    if(userEmail == '') {
        setTimeout(function(){
            $storeEmail.focus()
        },800)
    }

    $registerForm.addEventListener('submit', function(e){
        amplitude_log_event('tools_slogan_register_submited')
    })
}

function handleSteps(stepTo, stepFrom) {

    var $stepTo = document.querySelector('.js-step-' + stepTo),
        $stepFrom = document.querySelector('.js-step-' + stepFrom);

    function handleStep () {
        $stepFrom.classList.add('slide-toleft', 'is_inactive');
        $stepFrom.classList.remove('is_active');
        $stepFrom.setAttribute('aria-hidden', true);

        $stepTo.classList.remove('slide-toright','is_inactive', 'slide-toleft');
        $stepTo.classList.add('slide-in', 'is_active');
        $stepTo.setAttribute('aria-hidden', false);
    }

    handleHeight(stepTo);
    handleStep();
}

function handleHeight(stepTo) {
    var $forms = document.querySelector('.js-slogan-form'),
        $stepTo = document.querySelector('.js-step-' + stepTo),
        stepToTotalHeight = parseInt($stepTo.offsetHeight + $stepTo.style.marginTop + $stepTo.style.marginBottom);
    $forms.style.height =  stepToTotalHeight + 30 + 'px';
}

//TODO transform this into a class
var exit = function(e) {
    var shouldExit =
        e.target.className === 'close' || // user clicks on the close icon
        e.keyCode === 27; // user hits escape

    if (shouldExit) {
        $("#modal-subscribe").modal('hide');
    }
};

var mouseEvent = function(e) {
    var shouldShowExitIntent =
        !e.toElement &&
        !e.relatedTarget &&
        e.clientY < 10;

    if ( legacyLayout && shouldShowExitIntent && !hasSubscribeFlow ) {
        document.removeEventListener('mouseout', mouseEvent);
        $("#modal-subscribe").modal('show');
    }
};


function checkIfReady() {
    if (typeof Bouncer != 'undefined' && window.jQuery) {
        start();
    } else {
        setTimeout(checkIfReady, 500);
    }
}

checkIfReady();

